var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2533",
  "data-name": "Rectangle 2533",
  d: "M0,0H48a0,0,0,0,1,0,0V44a4,4,0,0,1-4,4H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
  fill: "#f6222c"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-heart",
  "data-name": "Icon feather-heart",
  d: "M28.164,6.619a7.459,7.459,0,0,0-10.421,0l-1.42,1.4-1.42-1.4a7.461,7.461,0,0,0-10.421,0,7.154,7.154,0,0,0,0,10.241l1.42,1.4L16.323,28.5,26.744,18.256l1.42-1.4a7.152,7.152,0,0,0,0-10.241Z",
  transform: "translate(7.677 7.503)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/heartfill.28589381.svg";
export { SvgComponent as ReactComponent };